import { IconButton, Input, InputGroup, Spinner } from "@chakra-ui/react"
import classnames from "classnames"
import PropTypes from "prop-types"
import { PureComponent } from "react"
import Pathicon from "../../pathicon/Pathicon"
import { withPortableContext } from "../../portable/Portable"
import PathwrightUI from "../../ui/PathwrightUI"

class SearchInput extends PureComponent {
  state = {
    value: ""
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextState) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value })
    }
  }

  handleChange = (e) => {
    if (this.props.value == null) {
      this.setState({ value: e.target.value })
    }
    if (this.props.onChange) {
      this.props.onChange(e.target.value, e)
    }
  }

  handleKeyUp = (e) => {
    if (this.props.onKeyUp) {
      this.props.onKeyUp(e.target.value, e)
    }
    if (this.props.onEnter && e.keyCode === 13) {
      this.props.onEnter(e.target.value, e)
    }

    // clear on escape key
    if (e.keyCode === 27) {
      this.handleClear()
    }
  }

  handleClear = (e) => {
    this.setState({ value: "" })
    if (this.props.onClear) {
      this.props.onClear()
    }
  }

  get value() {
    // defaulting to empty string to ensure the input value is controlled
    return this.props.value || this.state.value || ""
  }

  render() {
    const {
      typography,
      inverted,
      onEnter,
      onClear,
      className,
      style,
      icon,
      searching,
      allowFullscreen,
      size: sizeProp,
      ...rest
    } = this.props

    const { setPorting, porting } = this.props.context || {}
    const size = sizeProp || "sm"

    return (
      <PathwrightUI.Consumer contrast={1}>
        {({ backgroundColor, emphasis }) => {
          return (
            <InputGroup
              className="SearchInput"
              size={size}
              startElement={<Pathicon icon="search" />}
              endElement={
                searching ? (
                  <Spinner size={size} m={2} />
                ) : onClear && this.value ? (
                  <IconButton
                    variant="ghost"
                    size={size}
                    onClick={this.handleClear}
                    cursor="pointer"
                    bg="transparent"
                    _hover={{
                      bg: "transparent"
                    }}
                  >
                    <Pathicon icon="x" />
                  </IconButton>
                ) : setPorting && allowFullscreen ? (
                  porting ? (
                    <IconButton
                      variant="ghost"
                      size={size}
                      className="Fullscreen__minimize"
                      onClick={() => setPorting(false)}
                      cursor="pointer"
                      bg="transparent"
                      _hover={{
                        bg: "transparent"
                      }}
                    >
                      <Pathicon icon="minimize" />
                    </IconButton>
                  ) : (
                    <IconButton
                      variant="ghost"
                      size={size}
                      className="Fullscreen__maximize"
                      onClick={() => setPorting(true)}
                      cursor="pointer"
                      bg="transparent"
                      _hover={{
                        bg: "transparent"
                      }}
                    >
                      <Pathicon icon="maximize" />
                    </IconButton>
                  )
                ) : null
              }
            >
              <Input
                {...rest}
                type="text"
                size={size}
                className={classnames(className)}
                value={this.value}
                onKeyUp={this.handleKeyUp}
                onChange={this.handleChange}
                borderRadius="50px"
                bg={backgroundColor}
                border="none"
                outline="none"
                fontWeight="normal"
              />
            </InputGroup>
          )
        }}
      </PathwrightUI.Consumer>
    )
  }
}

SearchInput.displayName = "SearchInput"

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  icon: PropTypes.string,
  autoFocus: PropTypes.bool,
  searching: PropTypes.bool
}

SearchInput.defaultProps = {
  placeholder: "Search...",
  icon: "search",
  autoFocus: true,
  searching: false,
  allowFullscreen: false
}

export default withPortableContext(SearchInput)
